import "./css/history.css";

import SubHeader from "../components/subHeader";
import dompurify from "dompurify";
import { useTranslation } from "react-i18next";
import i18next from "../config/lang/i18next";
import React, { useRef, useEffect } from "react";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const History = () => {
  /* 언어 처리 */
  const { t, i18n } = useTranslation();
  const sanitizer = dompurify.sanitize;
  const language = useRef(null);

  useEffect(() => {
    language.current = sessionStorage.getItem("language");
    if (language === null) {
      language.current = cookies.get("language");
    }
    i18next.changeLanguage(language.current);
  }, []);
  return (
    <div className="wrapper">
      <SubHeader />
      <div className="section_title">
        <h1 className="headerText">{i18next.t("history.title")}</h1>
      </div>
      <div className="timeline">
        <div className="time_container left">
          <div className="date">2022</div>
          <div className="content">
            <p>{i18next.t("history.2022")}</p>
          </div>
        </div>
        <div className="time_container right">
          <div className="date">2018-2020</div>
          <div className="content">
            <p>{i18next.t("history.2018-2020")}</p>
          </div>
        </div>
        <div className="time_container left">
          <div className="date">2014-2015</div>
          <div className="content">
            <p>{i18next.t("history.2014-2015")}</p>
          </div>
        </div>
        <div className="time_container right">
          <div className="date">2013</div>
          <div className="content">
            <p>{i18next.t("history.2013")}</p>
          </div>
        </div>
        <div className="time_container left">
          <div className="date">2009-2012</div>
          <div className="content">
            <p>{i18next.t("history.2009-2012")}</p>
          </div>
        </div>
        <div className="time_container right">
          <div className="date">2008</div>
          <div className="content">
            <p>{i18next.t("history.2008")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default History;
